import { render, staticRenderFns } from "./OrderDeliveryPrepareIframe.vue?vue&type=template&id=c5091416&"
import script from "./OrderDeliveryPrepareIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderDeliveryPrepareIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports